/**
 * CyberGrid - 3D perspective animated grid background.
 *
 * Place inside a container with `relative overflow-hidden`.
 */

const CyberGrid = () => (
  <div className="cyber-grid" aria-hidden="true" />
);

export default CyberGrid;
